import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import AppCard from "@plannel/components/ui/AppCard";
import CardContent from '@mui/material/CardContent';
import InfoIcon from '@mui/icons-material/Info';
import { blue } from "@mui/material/colors";

import { withTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';

import { RouteList } from "@plannel/routeList";
import PlannelFooter from "@plannel/components/PlannelFooter";
import SelectLanguage from "@plannel/components/SelectLanguage"
import BackToSignIn from "@plannel/components/BackToSignIn";
import logo from "@plannel/assets/icons/main-logo.png";
import { FS } from "@plannel/utils/font-util";

const HelpSignin = ({ t }) => {
  const navigate = useNavigate();

  const navigateForgotPassword = () => {
    navigate(RouteList.ForgotPassword.path, { state: { modifiable: true } });
  }

  const listItemStyle = { color: blue.A400, cursor: 'pointer', my: 0.5, fontSize: FS.H1 };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }} >
        <Box mt={8}>
          <img src={logo} width={170} alt="loading..." />
        </Box>
        <Typography variant="h5" my={1}>{t("help")}</Typography>
        <Box mt={2} />
        <InfoIcon />
        <Typography variant="h6" fontSize={FS.DISPLAY} my={1}>{t("passwordAndSignIn")}</Typography>
        <AppCard sx={{ m: 1, width: "100%" }}>
          <CardContent sx={{ pb: '16px !important' }}>
            <Typography sx={listItemStyle} onClick={navigateForgotPassword} gutterBottom>{t("MSG_ForgotMyPassword")}</Typography>
            {/* <Divider sx={{ my: 2 }} />
            <Typography sx={listItemStyle} onClick={navigateForgotPassword} gutterBottom>{"Content to add"}</Typography> */}
          </CardContent>
        </AppCard>
      </Box>
      <Box sx={{ mt: 1, display: "flex" }}>
        <SelectLanguage />
        <BackToSignIn />
      </Box>
      <PlannelFooter/>
    </Container>
  );
};

export default withTranslation()(HelpSignin);